/* 0.44.31 - A stored color as CSS: a Henaket token ('--color-blue-800')
 * becomes var(--color-blue-800), a custom color ('#12AB34') stays as it
 * is; anything else (empty, unknown) gives null. Used wherever the
 * shared color picker's values are drawn. */
const TOKEN_RE = /^--color-[a-z0-9-]+$/;
const HEX_RE = /^#[0-9A-Fa-f]{6}$/;

export function colorCss(value) {
  if (!value || typeof value !== 'string') return null;
  const v = value.trim();
  if (TOKEN_RE.test(v)) return `var(${v})`;
  if (HEX_RE.test(v)) return v;
  return null;
}
